<template>
  <div>
    <PageTitle title="Queries" />
    <b-container fluid>
      <b-row class="first-row">
        <b-col xs="12" lg="6" xl="5" class="mb-3" order="0" order-lg="1">
          <QueryList class="fill-height" />
        </b-col>

        <b-col xs="12" lg="6" xl="7" class="mb-3" order="1" order-lg="0">
          <QueryEditor class="fill-height" />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <QueryResult />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';

import PageTitle from '@/components/PageTitle.vue';
import QueryEditor from '@/components/source-queries/QueryEditor.vue';
import QueryList from '@/components/source-queries/QueryList.vue';
import QueryResult from '@/components/source-queries/QueryResult.vue';

export default defineComponent({
  name: 'SourceQueries',
  components: {
    PageTitle,
    QueryEditor,
    QueryList,
    QueryResult,
  },
  computed: {
    ...mapState({
      loading: (state: any) => state.read.loading,
    }),
  },
  methods: {
    ...mapActions({
      addQuery: 'read/newRead',
      read: 'read/read',
    }),
  },
});
</script>
<style scoped>
.first-row {
  min-height: 250px;
}
</style>
